import { Box, Typography, CircularProgress } from '@mui/material'
import React from 'react'

interface Props {
  loadingText?: string
}
const FullScreenLoadingView = (props: Props) => (
  <Box
    sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
      backdropFilter: 'blur(4px)',
      zIndex: 50,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'center'}
      gap={3}
      sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        padding: '40px 60px',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
      }}
    >
      <CircularProgress
        size={60}
        thickness={4}
        sx={{
          color: '#7c3aed', // Purple to match your brand
          '& .MuiCircularProgress-circle': {
            strokeLinecap: 'round',
          },
        }}
      />
      <Typography
        variant='h6'
        fontWeight={600}
        color='#1a1a1a'
        sx={{
          fontSize: '18px',
        }}
      >
        {props.loadingText || 'Saving Data...'}
      </Typography>
    </Box>
  </Box>
)

export default FullScreenLoadingView
